module.exports = __webpack_public_path__ + "media/images/pngegg-5888946eef6525f331cb7a0cccc062d8.png";